const VoteType = {
	notSet: 'notSet',
	downVote: 'downVote',
	upVote: 'upVote',
};

export default VoteType;
